import React, { memo } from "react";
import { Link } from "react-router-dom";
import { displays } from "investira.react.lib";
import { Card, Stack, Typography, Chip } from "investira.react.components";
import { PessoaImage, MutedCopy } from "../../components/molecules";
import { ATIVO_MERCADO } from "@investirapri/financa.js/lib/enums";
import { PATHS } from "../../enums";
import { formats } from "investira.sdk";

const AtivosItem = memo((props) => {
  const {
    logo_pessoa_id,
    logo_ok,
    ativo,
    ifeed_ativo_id,
    ativo_seuid,
    mercado,
    emissor,
    emissor_cnpj,
    isin,
    ticker,
    serie,
    vencimento,
  } = props.data;

  const xPath = PATHS[mercado.toLowerCase()].path;

  return (
    <Card component="article">
      <Link
        to={`/ativos${xPath}/${ifeed_ativo_id}`}
        aria-label={`Ver detalhes de ${ticker || ativo || ativo_seuid}`}
      >
        <Stack direction="row" px={2} py={2} spacing={2}>
          <Stack>
            <PessoaImage
              logoPessoaId={logo_pessoa_id}
              alt={`Logo ${emissor.pessoa_fantasia || ativo}`}
              hasLogo={logo_ok}
              mercado={mercado}
              size={40}
            />
          </Stack>
          <Stack flexGrow={1} spacing={1}>
            <Stack flexGrow={1} direction="row">
              <Stack flexGrow={1}>
                <Stack flexGrow={1}>
                  <Typography
                    variant="body2"
                    color="textPrimary"
                    sx={{ fontWeight: 600 }}
                  >
                    {ticker || ativo_seuid || ativo}
                  </Typography>
                </Stack>
                {/* TODO: SE fundo mostrar o gestor e adm ao invés de ativo */}
                <Stack direction="row" flexGrow={1} spacing={1} mb={1}>
                  {ativo && (
                    <Typography variant="body2" color="textSecondary">
                      {ativo}
                    </Typography>
                  )}
                </Stack>
                <Stack direction="row" flexGrow={1} spacing={1}>
                  {emissor.pessoa_fantasia && (
                    <Typography variant="body2" color="textSecondary">
                      {emissor.pessoa_fantasia}
                    </Typography>
                  )}
                </Stack>
              </Stack>
              <Stack alignItems="flex-end">
                <Stack justifyContent="end">
                  <Chip
                    label={ATIVO_MERCADO[mercado].descricao}
                    size="small"
                    color="primary"
                  />
                </Stack>
              </Stack>
            </Stack>
            <Stack
              sx={{ gap: "8px 8px" }}
              flexWrap="wrap"
              alignItems="center"
              direction="row"
            >
              {emissor_cnpj && (
                <Chip
                  label={displays.cnpj(emissor_cnpj)}
                  size="small"
                  color="secondary"
                />
              )}

              {isin && (
                <MutedCopy value={isin}>
                  <Chip label={isin} size="small" color="secondary" />
                </MutedCopy>
              )}

              {serie && (
                <Chip
                  label={`Série: ${serie}`}
                  size="small"
                  color="secondary"
                />
              )}

              {vencimento && (
                <Chip
                  label={`Vencimento: ${formats.formatDate(vencimento)}`}
                  size="small"
                  color="secondary"
                />
              )}
            </Stack>
          </Stack>
        </Stack>
      </Link>
    </Card>
  );
});

export default AtivosItem;
